/* FF charts are isolated from Printdoors UPF charts. */
if (!customElements.get('ff-size-charts')) {
  customElements.define('ff-size-charts', class extends HTMLElement {
    connectedCallback() {
      this.onChange = this.onChange || ((event) => {
        if (event.target.matches('[data-ff-unit]') && this.contains(event.target)) this.syncUnit();
      });
      this.addEventListener('change', this.onChange);
      this.frame = requestAnimationFrame(() => { this.syncUnit(); });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
    }

    syncUnit() {
      const unit = this.querySelector('[data-ff-unit]:checked')?.value || 'in';
      this.querySelectorAll('[data-ff-measure]').forEach((cell) => {
        cell.textContent = cell.dataset[unit];
      });
      this.querySelectorAll('[data-ff-unit-label]').forEach((label) => { label.textContent = unit; });
    }
  });
}
